var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"app":"","color":"transparent"}},[_c('Header'),_c('v-main',[_c('Banner'),_c('Category'),_c('Events'),_c('UpcommingEvents'),_c('Featured'),_c('Footer'),_c('BackToTop')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }